import { makeStyles } from "@material-ui/core";

export const useMediaLibraryModalStyles = makeStyles((theme) => ({
	root: {
		minWidth: 900,
		maxWidth: "80rem",
		maxHeight: "90vh",
	},
	dialogTitle: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "16px",
		backgroundColor: "#fff",
		color: theme.palette.text.primary,
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	closeButton: {
		color: theme.palette.text.secondary,
		"&:hover": {
			backgroundColor: theme.palette.action.hover,
		},
	},
	content: {
		padding: theme.spacing(2, 3),
		paddingBottom: 0,
		overflow: "auto",
		display: "flex",
		flexDirection: "column",
		flexGrow: 1,
	},
	actionButton: {
		marginRight: theme.spacing(1),
		borderRadius: 4,
		fontWeight: 500,
	},
	deleteButton: {
		color: theme.palette.error.main,
		borderColor: theme.palette.error.main,
		fontWeight: 500,
		"&:hover": {
			backgroundColor: theme.palette.error.main + "10",
			borderColor: theme.palette.error.dark,
		},
	},
	largerTooltip: {
		fontSize: "0.9rem",
		padding: "8px 12px",
	},
	footer: {
		borderTop: `1px solid ${theme.palette.divider}`,
		padding: theme.spacing(2, 3),
		backgroundColor: theme.palette.grey[50],
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		minHeight: 64,
		flexShrink: 0,
	},
	footerLeft: {
		display: "flex",
		alignItems: "center",
		color: theme.palette.text.secondary,
		minHeight: 36,
	},
	footerRight: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
	},
	selectionCount: {
		fontWeight: 500,
		color: theme.palette.primary.main,
	},
	selectionChip: {
		backgroundColor: theme.palette.primary.main,
		color: "#fff",
		borderRadius: 16,
		padding: "0 12px",
		fontSize: "0.875rem",
		fontWeight: 600,
		display: "inline-grid",
		placeItems: "center",
		height: 32,
	},
	downloadButton: {
		marginRight: theme.spacing(1),
		color: theme.palette.primary.main,
		borderColor: theme.palette.primary.main,
		fontWeight: 500,
		"&:hover": {
			backgroundColor: theme.palette.primary.main + "10",
			borderColor: theme.palette.primary.dark,
		},
	},
	headerStats: {
		display: "flex",
		alignItems: "center",
		color: theme.palette.text.primary,
		marginRight: theme.spacing(2),
	},
	statsIcon: {
		marginRight: theme.spacing(1),
		fontSize: "2rem",
		color: theme.palette.primary.main,
	},
	statsText: {
		fontSize: "0.875rem",
		lineHeight: 1.2,
	},
	statsNumbers: {
		fontSize: "1.25rem",
		fontWeight: 600,
	},
	statsDetails: {
		fontSize: "1rem",
		opacity: 0.7,
		marginTop: 2,
		color: theme.palette.text.secondary,
	},
	uploadModalRoot: {
		minWidth: 1280,
		maxWidth: "70rem",
		maxHeight: "80vh",
	},
	uploadModalTitle: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "16px",
		backgroundColor: "#fff",
		color: theme.palette.text.primary,
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	uploadModalContent: {
		padding: theme.spacing(2, 3),
		overflow: "auto",
	},
	selectionInfo: {
		marginLeft: theme.spacing(2),
	},
}));

export const useMediaGridStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	gridContainer: {
		margin: 0,
		width: "100%",
	},
	emptyState: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(6),
		color: theme.palette.text.secondary,
		height: 300,
		backgroundColor: theme.palette.background.default,
		borderRadius: theme.shape.borderRadius,
	},
	emptyIcon: {
		fontSize: 48,
		marginBottom: theme.spacing(2),
		color: theme.palette.grey[400],
	},
	loadingContainer: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(4),
	},
	loadingItem: {
		height: "100%",
		borderRadius: theme.shape.borderRadius,
		overflow: "hidden",
	},
	loadingMedia: {
		paddingTop: "75%",
		borderTopLeftRadius: theme.shape.borderRadius,
		borderTopRightRadius: theme.shape.borderRadius,
	},
	loadingContent: {
		padding: theme.spacing(1.5),
	},
}));

export const useMediaItemStyles = makeStyles((theme) => ({
	root: {
		borderRadius: "10px",
		overflow: "hidden",
		transition: "transform 0.2s, box-shadow 0.2s",
		boxShadow: theme.shadows[2],
		height: "9rem",
		aspectRatio: "1 / 1",
		"&:hover": {
			transform: "translateY(-4px)",
			boxShadow: theme.shadows[6],
		},
	},
	staticRoot: {
		borderRadius: "10px",
		overflow: "hidden",
		boxShadow: theme.shadows[2],
		height: "9rem",
		aspectRatio: "1 / 1",
	},
	mediaContainer: {
		position: "relative",
		paddingTop: "100%",
		height: 0,
	},
	media: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		objectFit: "cover",
	},
	mediaWrapper: {
		position: "relative",
	},
	copyButton: {
		position: "absolute",
		top: theme.spacing(1),
		left: theme.spacing(1),
		zIndex: 2,
		color: "#fff",
		backgroundColor: "rgba(0, 0, 0, 0.3)",
		padding: theme.spacing(1),
		"& .MuiSvgIcon-root": {
			fontSize: 16,
		},
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
		},
		transition: "background-color 0.2s ease",
	},
	overlay: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		opacity: 0,
		transition: "opacity 0.2s ease",
		"&:hover": {
			opacity: 1,
		},
	},
	overlayTop: {
		padding: theme.spacing(1),
		color: "#fff",
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
	},
	overlayBottom: {
		padding: theme.spacing(1),
		color: "#fff",
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		transition: "background-color 0.2s ease",
	},
	copyIcon: {
		fontSize: 18,
	},
	copySuccessWrapper: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		pointerEvents: "none",
		zIndex: 30,
	},
	copySuccessBadge: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		color: "#fff",
		backgroundColor: "rgba(76, 175, 80, 0.8)",
		borderRadius: "50%",
		width: 60,
		height: 60,
	},
	successIcon: {
		fontSize: 28,
		marginBottom: theme.spacing(0.5),
	},
	mediaPreview: {
		maxWidth: "100%",
		maxHeight: "90vh",
		objectFit: "contain",
	},
	modalCloseButton: {
		position: "absolute",
		top: theme.spacing(1),
		right: theme.spacing(1),
		color: "#fff",
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		"&:hover": {
			backgroundColor: "rgba(0, 0, 0, 0.7)",
		},
	},
	previewContent: {
		position: "relative",
		padding: "0 !important",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "rgba(0, 0, 0, 0.9)",
	},
	skeletonMedia: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
	},
	zoomIcon: {
		color: "#fff",
		fontSize: 32,
	},
	videoMediaContainer: {
		cursor: "default",
	},
	pdfButton: {
		padding: 0,
		width: "100%",
		height: "100%",
		textTransform: "none",
		borderRadius: theme.shape.borderRadius,
		display: "block",
		"& .MuiTouchRipple-root": {
			display: "none",
		},
		"&:hover": {
			backgroundColor: "transparent",
		},
	},
	pdfContainer: {
		position: "relative",
		paddingTop: "100%",
		height: 0,
		width: "100%",
		overflow: "hidden",
	},
	pdfThumbnail: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		objectFit: "contain",
	},
	pdfPlaceholder: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: theme.palette.grey[200],
	},
	pdfIcon: {
		fontSize: 48,
		color: theme.palette.primary.main,
	},
	pdfOverlay: {
		position: "absolute",
		bottom: 0,
		left: 0,
		right: 0,
		height: "33.3%",
		width: "100%",
		padding: theme.spacing(0.75),
		backgroundColor: "transparent",
		backgroundImage:
			"linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.9) 100%)",
		color: "#fff",
		zIndex: 1,
		display: "flex",
		alignItems: "flex-end",
	},
	pdfCaption: {
		display: "block",
		width: "100%",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		textAlign: "left",
		fontSize: "0.75rem",
	},
	selectionCheckbox: {
		padding: 5,
		"& .MuiSvgIcon-root": {
			position: "relative",
			backgroundColor: "white",
			borderRadius: 2,
			fontSize: 22,
			color: theme.palette.primary.main,
		},
	},
	checkboxContainer: {
		position: "absolute",
		top: 8,
		left: 0,
		zIndex: 20,
	},
	selectionModeCard: {
		"&:hover": {
			transform: "none",
			boxShadow: theme.shadows[2],
		},
	},
}));

export const useMediaUploaderStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	dropzone: {
		minHeight: 300,
		padding: theme.spacing(2),
	},
	buttonContainer: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: theme.spacing(2),
	},
	uploadButton: {
		marginLeft: theme.spacing(2),
	},
	uploadSuccess: {
		display: "flex",
		alignItems: "center",
		marginTop: theme.spacing(2),
		color: theme.palette.success.main,
	},
	successIcon: {
		marginRight: theme.spacing(1),
	},
}));

export const useImagePreviewModalStyles = makeStyles((theme) => ({
	imageContainer: {
		position: "relative",
		flex: "1",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		minHeight: 0,
		margin: "0 15rem",
	},
	image: {
		position: "absolute",
		margin: "0 auto",
		display: "flex",
		justifyContent: "center",
		width: "100%",
		maxHeight: "100%",
	},
	imageContent: {
		objectFit: "contain",
		maxWidth: "100%",
		height: "auto",
	},
	closeButton: {
		color: "#fff",
		backgroundColor: "rgba(0, 0, 0, 0.6)",
		borderRadius: "50%",
		padding: theme.spacing(1),
		zIndex: 2,
		"&:hover": {
			backgroundColor: "#ffffff1a",
		},
	},
	copyButton: {
		color: "#fff",
		backgroundColor: "rgba(0, 0, 0, 0.6)",
		borderRadius: "50%",
		padding: theme.spacing(1),
		zIndex: 2,
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
		},
	},
	navButton: {
		position: "relative",
		color: "#fff",
		"&:hover": {
			backgroundColor: "#ffffff1a",
		},
	},
	navLeft: {
		right: "4rem",
	},
	navRight: {
		left: "4rem",
	},
}));
